import React from 'react';
import { Box } from '@mui/material';
import './Loader.css';

const DotLoader = () => {
  return (
    <Box className="dot-loader-container">
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </Box>
  );
};

export default DotLoader;